import { ButtonComp } from 'atoms/Buttons';
import { onTrackOrderBtnClickHandler } from '../../utils/HeaderTrackOrderUtils';
import { redirectToOrderProcessingPage, redirectToAccountPage } from 'common/utilities/utils';
import { ROUTE_URL } from 'common/constants/SharedConstants';

export const getHeaderTrackOrderTemplates = params => {
  const { headerTrackDetails } = params;
  const { trackOrderTitle, trackOrderButtonLabel } = headerTrackDetails;
  return (
    <div className='headerTrackOrderPanel au col-12' data-testid='header-track-order-items'>
      <div className='headBottomParent col-12'>
        <div className='head-track-order-Txt'>
          <span>{trackOrderTitle}</span>
        </div>
        <div className='header-track-order-btn'>
          <ButtonComp
            data-testid='header-Track-order-button'
            className='button'
            aria-label={trackOrderButtonLabel}
            onClickHandler={() => onTrackOrderBtnClickHandler({ ...params, redirectTo: redirectToOrderProcessingPage })}
            id='headerTrackOrderItemButton'
            type='submit'
          >
            <span>{trackOrderButtonLabel}</span>
          </ButtonComp>
        </div>
      </div>
    </div>
  );
};

export const getHeaderPickupOrderCancelledBanner = params => {
  const { headerTrackDetails } = params;
  const { pickupOrderCancelledTitle, pickupOrderCancelledButtonLabel, useHistoryHook, userStatus } = headerTrackDetails;

  return (
    <div className='headerTrackOrderPanel au col-12' data-testid='header-track-order-items'>
      <div className='headBottomParent col-12'>
        <div className='head-track-order-Txt'>
          <span>{pickupOrderCancelledTitle}</span>
        </div>
        {userStatus?.loggedIn && (
          <div className='header-track-order-btn'>
            <ButtonComp
              data-testid='pickup-order-cancelled-button'
              className='button order-history-button'
              aria-label={pickupOrderCancelledButtonLabel}
              onClickHandler={() => redirectToAccountPage(useHistoryHook, ROUTE_URL.ORDER_HISTORY)}
              id='headerTrackOrderItemButton'
              type='submit'
            >
              <span>{pickupOrderCancelledButtonLabel}</span>
            </ButtonComp>
          </div>
        )}
      </div>
    </div>
  );
};
